import React, { memo, useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Tile from 'components/shared/Tile'
import VersionCard from 'components/VTA/VersionCard'
import useMediaQuery from '@mui/material/useMediaQuery'
import SearchIcon from '@mui/icons-material/Search'
import Divider from '@mui/material/Divider'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse } from '@mui/material'
import ContainerComponent from 'components/shared/ContainerComponent'
import { titleCaps } from 'utils/universal'
import sx from './styles'

const TilePicker = (props) => {
  const {
    id,
    hiddenMobile = false,
    sx: sxProp,
    label,
    emptyLabel,
    value,
    onChange,
    labelVariant = 'body1',
    // valueVariant = 'body2',
    variant = 'flexible', // row, column, flexible, card
    searchTextFieldProps = {},
    options,
    gridItemProps = {
      xs: 6,
      sm: 4,
      md: 3,
    },
    renderIcon = () => null,
    renderItem = (item) => item,
    minOptionsBeforeHideSearch = 15,
    filterByName = false,
    step,
    topChildren = null,
  } = props

  const [search, setSearch] = useState('')
  const [isVisibleDropDown, setIsVisibleDropDown] = useState(true)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  let sxIconContainer = {}

  const filterFunction = (item) => {
    if (!search) return true
    if (filterByName) {
      return `${item.name}`.toLowerCase().includes(search.toLocaleLowerCase())
    }
    return `${item}`.toLowerCase().includes(search.toLocaleLowerCase())
  }

  const handleClik = (v) => () => {
    onChange(v)
  }

  const getTextStyles = (text) => {
    sxIconContainer = sx.iconContainer
    if (text === 'Otro') {
      sxIconContainer = { ...sxIconContainer, ...sx.transparentIcon }
    }
    return sxIconContainer
  }

  const getMostValues = () => {
    if (search.length > 0) return options
    if (step === 'marker') return options.length > 0 ? options.filter((item, i) => i < 12) : []
    return options.length > 0 ? options : []
  }

  const getMoreValues = () => {
    if (search.length > 0) return []
    return options.length > 0 ? options.filter((item, i) => i > 11) : []
  }

  const mostValued = getMostValues()
  const more = getMoreValues()
  const textDropDownBtn = isVisibleDropDown ? 'Ver menos' : 'Ver más'
  const sxDropDownButon = !isVisibleDropDown
    ? { ...sx.dropDownButtonContainer, ...sx.dropDownButtonContainerUp }
    : { ...sx.dropDownButtonContainer, ...sx.dropDownButtonContainerDown }
  return (
    <ContainerComponent>
      <Box
        id={id}
        sx={{ ...sxProp }}
      >
        <Typography
          sx={sx.label}
          variant={labelVariant}
          py={2}
        >
          {label}
        </Typography>
        {topChildren}

        {(isMobile || options.length > minOptionsBeforeHideSearch) && (step !== 'version') && !hiddenMobile && (
          <TextField
            sx={sx.textField}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: <SearchIcon sx={{ color: 'common.black' }} />,
            }}
            {...searchTextFieldProps}
          />
        )}
        <Grid
          container
          pb={2}
        >
          {step === 'marker' && search.length === 0 && (
            <Grid
              size={12}
              mb={2}
            >
              <Typography
                sx={sx.subititle}
                variant="caption"
              >
                Las más buscadas
              </Typography>
            </Grid>
          )}
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
            }}
          >
            {mostValued
              ?.filter(filterFunction).map((item, i) => (
                <Grid
                  key={i}
                  sx={sx.gridItem}
                  size={{ ...gridItemProps }}
                  alignItems="stretch"
                  className="macc"
                >
                  {variant === 'card' ? (
                    <VersionCard
                      id={`tile-item-${item.id}`}
                      item={item}
                      selected={value === item.name}
                      onClick={handleClik(item)}
                    />
                  ) : (
                    <Tile
                      id={`tile-item-${item}`}
                      sx={sx.tile}
                      selected={value === item}
                      onClick={handleClik(item)}
                      sxIcon={getTextStyles(item)}
                      sxText={sx.textContainer}
                      text={(
                        <Typography
                          id={`tile-text-make-${item}`}
                        >
                          {titleCaps(renderItem(item))}
                        </Typography>
                      )}
                      icon={renderIcon(item)}
                      variant={variant}
                    />
                  )}
                </Grid>
              ))}
          </Grid>
          {step === 'marker' && (
            <>
              {search.length === 0
                && (
                  <>
                    <Divider
                      flexItem
                      textAlign="center"
                      sx={sx.divider}
                    />
                    <Grid size={12}>
                      <Typography
                        sx={sx.subititle}
                        variant="caption"
                      >
                        Resto de Marcas
                      </Typography>
                    </Grid>
                  </>
                )}
              <Collapse
                in={isVisibleDropDown}
                collapsedSize={140}
                timeout={1000}
                sx={sx.dropDown}
              >
                <Grid
                  container
                  spacing={2}
                  mt={1}
                >
                  {more.filter(filterFunction).map((item, i) => (
                    <Grid
                      key={i}
                      sx={sx.gridItemDown}
                      size={{ ...gridItemProps }}
                      alignItems="stretch"
                    >
                      {variant === 'card' ? (
                        <VersionCard
                          id={`tile-item-${item.id}`}
                          item={item}
                          selected={value === item.name}
                          onClick={handleClik(item)}
                        />
                      ) : (
                        <Tile
                          id={`tile-item-${item}`}
                          sx={sx.tile}
                          selected={value === item}
                          onClick={handleClik(item)}
                          sxIcon={getTextStyles(item)}
                          sxText={sx.textContainer}
                          text={(
                            <Typography
                              id={`tile-text-make-${item}`}
                            >
                              {titleCaps(renderItem(item))}
                            </Typography>
                          )}
                          icon={renderIcon(item)}
                          variant={variant}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
                {!search && (
                  <Box sx={sxDropDownButon}>
                    <Typography
                      variant="caption"
                      onClick={() => setIsVisibleDropDown(!isVisibleDropDown)}
                      sx={sx.dropDownButton}
                    >
                      {isVisibleDropDown && <KeyboardArrowUpIcon />}
                      {textDropDownBtn}
                      {!isVisibleDropDown && <KeyboardArrowDownIcon />}
                    </Typography>
                  </Box>
                )}
              </Collapse>
            </>
          )}
        </Grid>
        <Typography>{emptyLabel}</Typography>
      </Box>
    </ContainerComponent>
  )
}

export default memo(TilePicker)
